import { useState, useEffect, useMemo } from 'react'
import * as FiIcons from 'react-icons/fi'
import ArticoloRow from './ArticoloRow'
import {
  DrawerOverlay,
  DrawerContainer,
  DrawerHeader,
  DrawerHeaderTop,
  DrawerTitle,
  CloseButton,
  SearchContainer,
  SearchInput,
  SearchIcon,
  DrawerBody,
  DrawerFooter,
  FooterText,
  Badge,
  EmptyState,
  EmptyStateIcon,
  EmptyStateText
} from './ArticoliDrawer.styles'

export default function ArticoliDrawer ({
  isOpen,
  onClose,
  settore,
  items, // articoli o servizi
  itemsGiaAggiunti, // array di IDs già nel carrello
  onAddItem,
  onInfo,
  tipo, // 'articoli' o 'servizi'
  valuta
}) {
  const [searchTerm, setSearchTerm] = useState('')

  // Reset search quando drawer si chiude
  useEffect(() => {
    if (!isOpen) {
      setSearchTerm('')
    }
  }, [isOpen])

  // Chiudi con ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose()
      }
    }
    document.addEventListener('keydown', handleEsc)
    return () => document.removeEventListener('keydown', handleEsc)
  }, [isOpen, onClose])

  // Filtra items in base alla search
  const filteredItems = useMemo(() => {
    if (!searchTerm.trim()) return items

    const term = searchTerm.toLowerCase()
    return items.filter(item => {
      if (tipo === 'articoli') {
        return (
          item.titolo?.toLowerCase().includes(term) ||
          item.referenza?.toLowerCase().includes(term) ||
          item.modello?.toLowerCase().includes(term) ||
          item.marca?.toLowerCase().includes(term) ||
          item.fornitore?.fornitore?.toLowerCase().includes(term) ||
          item.produttore?.produttore?.toLowerCase().includes(term)
        )
      } else {
        return (
          item.titolo?.toLowerCase().includes(term) ||
          item.descrizione?.toLowerCase().includes(term)
        )
      }
    })
  }, [items, searchTerm, tipo])

  // Check se item è già aggiunto
  const isItemAdded = (itemId) => {
    return itemsGiaAggiunti.includes(itemId)
  }

  // Count articoli aggiunti
  const countAggiunti = itemsGiaAggiunti.length

  const handleOverlayClick = (e) => {
    // Chiudi solo se click sull'overlay, non sul drawer
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <>
      <DrawerOverlay isOpen={isOpen} onClick={handleOverlayClick} />
      <DrawerContainer isOpen={isOpen}>
        <DrawerHeader>
          <DrawerHeaderTop>
            <DrawerTitle>
              {tipo === 'articoli' ? 'Aggiungi Materiale' : 'Aggiungi Servizi'}
            </DrawerTitle>
            <CloseButton onClick={onClose} title='Chiudi (ESC)'>
              <FiIcons.FiX size={24} />
            </CloseButton>
          </DrawerHeaderTop>

          <SearchContainer>
            <SearchIcon>
              <FiIcons.FiSearch size={18} />
            </SearchIcon>
            <SearchInput
              type='text'
              placeholder={`Cerca ${tipo === 'articoli' ? 'per titolo, referenza, marca...' : 'per titolo o descrizione...'}`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </SearchContainer>
        </DrawerHeader>

        <DrawerBody>
          {filteredItems.length > 0
            ? (
                filteredItems.map(item => (
                  <ArticoloRow
                    key={item._id}
                    item={item}
                    tipo={tipo}
                    isAdded={isItemAdded(item._id)}
                    onAdd={onAddItem}
                    onInfo={onInfo}
                    valuta={valuta}
                  />
                ))
              )
            : (
              <EmptyState>
                <EmptyStateIcon>
                  <FiIcons.FiInbox />
                </EmptyStateIcon>
                <EmptyStateText>
                  {searchTerm
                    ? `Nessun ${tipo === 'articoli' ? 'articolo' : 'servizio'} trovato`
                    : `Nessun ${tipo === 'articoli' ? 'articolo' : 'servizio'} disponibile`}
                </EmptyStateText>
              </EmptyState>
              )}
        </DrawerBody>

        <DrawerFooter>
          <FooterText>
            {tipo === 'articoli' ? 'Articoli' : 'Servizi'} nel carrello:
            <Badge>{countAggiunti}</Badge>
          </FooterText>
          <CloseButton onClick={onClose}>
            <FiIcons.FiX size={20} />
            Chiudi
          </CloseButton>
        </DrawerFooter>
      </DrawerContainer>
    </>
  )
}
